<template>
  <div class="banner" :style="{backgroundImage: 'url(' + bgImage + ')' }">
  </div>
</template>

<script>
export default {
  name: 'banner',
  data () {
    return {
    }
  },
  props:[
    'bgImage'
  ],
  mounted(){
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.banner{
  width: 100%;
  height: 500px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
</style>



// WEBPACK FOOTER //
// src/components/banner.vue